import AutoAwesomeRoundedIcon from '@mui/icons-material/AutoAwesomeRounded';
import CampaignRoundedIcon from '@mui/icons-material/CampaignRounded';
import WorkspacePremiumRoundedIcon from '@mui/icons-material/WorkspacePremiumRounded';
import { Chip, Stack, styled } from '@mui/material';
import { memo } from 'react';
import { useTranslation } from 'react-i18next';
import type ViewProductStore from '../../AppData/_stores/ViewProductStore';

interface ProductCatalogCardBadgesProps {
  product: ViewProductStore
}

const ProductBadges = styled(Stack)(({ theme }) => ({
  alignItems: 'flex-end',
  maxWidth: 'calc(100% - ' + theme.spacing(7) + ')',
  pointerEvents: 'none',
  position: 'absolute',
  right: theme.spacing(1),
  top: theme.spacing(1),
  zIndex: 9,
}));

const ProductBadge = styled(Chip)({
  maxWidth: '100%',
});

function ProductCatalogCardBadges(props: ProductCatalogCardBadgesProps) {
  const [t] = useTranslation('products');
  const featured = props.product.get('featured_order') !== null;
  const bestseller = props.product.get('bestseller_order') !== null;
  const isNew = props.product.get('is_new');

  if (!featured && !bestseller && !isNew) {
    return null;
  }

  return <ProductBadges spacing={0.5}>
    {featured ? <ProductBadge
      color="secondary"
      icon={<AutoAwesomeRoundedIcon />}
      label={t('Featured')}
      variant="badge"
    /> : null}
    {bestseller ? <ProductBadge
      color="accent"
      icon={<WorkspacePremiumRoundedIcon />}
      label={t('Bestseller')}
      variant="badge"
    /> : null}
    {isNew ? <ProductBadge
      color="primary"
      icon={<CampaignRoundedIcon />}
      label={t('New')}
      variant="badge"
    /> : null}
  </ProductBadges>;
}

export default memo(ProductCatalogCardBadges);
